import React from "react";
import Container from "../../components/Container/Container";
import { Col } from "react-bootstrap";

const Skincare_Products = () => {
  return (
    <Container>
      <Col>
        <h1>Skincare</h1>
      </Col>
    </Container>
  );
};

export default Skincare_Products;
